import { ClipLoader } from "react-spinners";

type Props = {
  isLoading: boolean;
  color?: string;
};

export const PageLoader = ({ isLoading, color }: Props) => {
  if (!isLoading) return null;
  return (
    <div className="absolute inset-0 z-[2] flex items-center justify-center bg-white/80 backdrop-blur-sm">
      <ClipLoader color={color} size={50} />
    </div>
  );
};
